<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subheading">{{ $t('labels.softwareInformation') }}</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small="small" color="pink" dark icon @click="dialog = true">
        <v-icon small="small">edit</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-layout column="column">
        <v-layout row wrap>
          <v-flex>{{ $t('labels.software') }}</v-flex>
          <v-spacer></v-spacer>
          <v-flex class="font-weight-regular text-xs-right" v-if="service.pos.cSoftware">{{
          service.pos.cSoftware.selector }}</v-flex>
          <v-flex class="font-weight-regular text-xs-right" v-else="v-else">Not Selected</v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex>{{ $t('labels.plan') }}</v-flex>
          <v-spacer></v-spacer>
          <v-flex class="font-weight-regular text-xs-right">{{ service.pos.Product.productDetail }}</v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex>{{ $t('labels.monthly') }}</v-flex>
          <v-spacer></v-spacer>
          <v-flex class="font-weight-regular text-xs-right">{{ service.pos.softwareFee | currency }}</v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap v-if="!service.csp4">
          <v-flex>{{ $t('labels.currentVersion') }}</v-flex>
          <v-spacer></v-spacer>
          <v-flex class="font-weight-regular text-xs-right">{{ location.softwareCurrentVersion }}</v-flex>
        </v-layout>
        <v-divider v-if="!service.csp4"></v-divider>
        <v-layout row wrap v-if="!service.csp4">
          <v-flex>{{ $t('labels.versionLimit') }}</v-flex>
          <v-spacer></v-spacer>
          <v-flex class="font-weight-regular text-xs-right">{{ location.UpdateSoftwareVersion }}</v-flex>
        </v-layout>
        <v-divider v-if="!service.csp4"></v-divider>
        <v-layout row wrap v-if="location.leadID">
          <v-flex>{{ $t('labels.convertedLeadID') }}</v-flex>
          <v-spacer></v-spacer>
          <v-flex class="font-weight-regular text-xs-right">{{ location.leadID }}</v-flex>
        </v-layout>
        <v-divider v-if="location.leadID"></v-divider>
        <v-layout row wrap>
          <v-flex>{{ $t('labels.lastUsed') }}</v-flex>
          <v-spacer></v-spacer>
          <v-flex class="font-weight-regular text-xs-right"><span>{{ location.AttandanceDateTime | moment("MM/DD/YYYY")
              }} | </span>
            <v-tooltip bottom=""><template v-slot:activator="{ on }"><a v-on="on" @click="openTransaction">{{
          location.AttandanceDateTime | moment("from", "now") }}</a></template><span>{{
          $t('labels.viewLast20Transaction') }}</span></v-tooltip>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex>{{ $t('labels.ipAddressList') }}</v-flex>
          <v-spacer></v-spacer>
          <v-flex class="font-weight-regular text-xs-right"> <a @click="getIpAddressList()">View List</a></v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex>Text Alert Number</v-flex>
          <v-spacer></v-spacer>
          <v-flex class="font-weight-regular text-xs-right"> <a @click="OpenSaleAlert()">View List</a></v-flex>
          <!-- <v-flex class="font-weight-regular text-xs-right">

            <div v-if="cellNumberLoading">
              <v-progress-circular size='20' indeterminate color="deep-orange lighten-2"></v-progress-circular>
            </div>
            <v-layout column v-else>
              <v-flex class="font-weight-regular text-xs-right">{{alertData[0].Phone1}}</v-flex>
              <v-flex class="font-weight-regular text-xs-right">{{alertData[0].Phone2}}</v-flex>
            </v-layout>
          </v-flex> -->

        </v-layout>
      </v-layout>
    </v-card-text>
    <IPAddressList :storeID="location.storeID" :ipAddressDialog="showIpAddress" @close="showIpAddress = false">
    </IPAddressList>
    <Last20TransactionList :storeID="location.storeID" :transactionDialog="transactionDialog" @close="closeTransaction">
    </Last20TransactionList>
    <v-dialog v-model="dialog" persistent="persistent" max-width="300">
      <v-card>
        <v-toolbar class="elevation-0" height="45" color="gray">
          <v-toolbar-title>
            <h1 class="subheading">{{ $t('labels.plan') }}</h1>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="!isLoading">
          <v-layout row wrap>
            <v-flex xs12="xs12">
              <v-select :items="comboBoxByID(3).ComboBoxDetails" :label="$t('labels.software')"
                :error-messages="softwareErrors" item-text="selector" item-value="id"
                v-model="editLocation.cSoftwareID"></v-select>
            </v-flex>
            <v-flex xs12="xs12" v-if="checkRightStatus(11)">
              <v-select :items="softwareProduct" :error-messages="productErrors" :label="$t('labels.plan')"
                item-text="productDetail" item-value="productID" v-model="editLocation.productID"></v-select>
            </v-flex>
            <v-flex xs12="xs12" v-if="checkRightStatus(10)">
              <v-text-field class="right-input" v-model="editLocation.softwareFee" :error-messages="softwareFeeErrors"
                label="Fee"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat="flat" @click="close">Close</v-btn>
          <v-btn color="info" @click="update">update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSaleAlertNumber" persistent="persistent" max-width="300">
      <v-card>
        <v-toolbar class="elevation-0" height="45" color="gray">
          <v-toolbar-title>
            <h1 class="subheading">Cell Number</h1>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="alertData">
          <v-layout column>

            <v-flex class="font-weight-regular ">
              <v-layout row wrap>
                <v-flex>Cell Phone 1</v-flex>
                <v-flex class="text-xs-right">{{ alertData[0].Phone1 }}</v-flex>
              </v-layout>

            </v-flex>

            <v-flex class="font-weight-regular ">
              <v-layout row wrap>
                <v-flex>Cell Phone 2</v-flex>
                <v-flex class="text-xs-right">{{ alertData[0].Phone2 }}</v-flex>
              </v-layout>

            </v-flex>

          </v-layout>
        </v-card-text>
        <v-card-text v-else>
          <div>No number found</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat="flat" @click="closeSaleAlert">Close</v-btn>
          <!-- <v-btn color="info" @click="update">update</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Last20TransactionList from '../Last20TransactionList'
import locationService from '../../service.js'
import IPAddressList from '../../../Global/components/IPAddressList'

const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
  minValue,
} = require('vuelidate/lib/validators')

export default {
  data() {
    return {
      dialogSaleAlertNumber: false,
      cellNumberLoading: false,
      alertData: null,
      dialog: false,
      isLoading: true,
      transactionDialog: false,
      showIpAddress: false,
      softwareProduct: [],
      editLocation: null,
    }
  },
  components: {
    IPAddressList,
    Last20TransactionList,
  },
  methods: {
    ...mapActions('location', ['setLocation']),
    async OpenSaleAlert() {
      await this.getSaleAlert()
      if (!this.alertData) {
        console.log('saqib', this.alertData)
      } else {
        console.log('alert', this.alertData)
        this.dialogSaleAlertNumber = !this.dialogSaleAlertNumber
      }

    },
    getSaleAlert() {
      console.log('thsi.location', this.location)
      return locationService.getSaleAlert(this.location.storeID)
        .then(response => {
          this.cellNumberLoading = true
          this.alertData = response.data
          // console.log('this.alertData', this.alertData)
        }).catch(error => {
          console.log('error', error)
        })
    },
    closeSaleAlert() {
      this.cellNumberLoading = false
      this.alertData = null
      this.dialogSaleAlertNumber = !this.dialogSaleAlertNumber
    },
    close() {
      this.dialog = false
    },
    update() {
      let editData = {
        cSoftwareID: this.editLocation.cSoftwareID,
        productID: this.editLocation.productID,
        softwareFee: this.editLocation.softwareFee,
      }
      return locationService.updateProductRelation(this.editLocation.storeID, this.service.pos.serviceID, this.editLocation)
        .then(result => {
          this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: 'success',
            title: 'Update Successfully'
          })
          this.close()
          this.setLocation(this.editLocation.storeID)
        })
    },
    openTransaction() {
      this.transactionDialog = true
    },
    closeTransaction() {
      this.transactionDialog = false
    },
    getIpAddressList() {
      this.showIpAddress = true
    },
    getServiceProduct() {
      return locationService.getServiceProduct(this.service.pos.serviceID)
        .then(result => {
          console.log('product', result)
          this.softwareProduct = result.data
        })
    },
  },
  watch: {
    // dialogSaleAlertNumber(val) {
    //   if (val) {
    //     this.getSaleAlert()
    //   }
    // },
    dialog(val) {
      if (val) {
        this.getServiceProduct()
        this.editLocation = _.clone(this.location)
        this.isLoading = false
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    editLocation: {
      cSoftwareID: {
        required,
        minValue: minValue(1),
      },
      productID: {
        required,
        minValue: minValue(1),
      },
      softwareFee: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters('location', ['location', 'service']),
    ...mapGetters('global', ['comboBox', 'comboBoxByID', 'checkRightStatus']),
    softwareErrors() {
      const errors = []
      if (!this.$v.editLocation.cSoftwareID.$dirty) return errors
      if (!this.$v.editLocation.cSoftwareID.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    productErrors() {
      const errors = []
      if (!this.$v.editLocation.productID.$dirty) return errors
      if (!this.$v.editLocation.productID.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    softwareFeeErrors() {
      const errors = []
      if (!this.$v.editLocation.softwareFee.$dirty) return errors
      if (!this.$v.editLocation.softwareFee.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
  }

}
</script>

<style scoped></style>
